<div class="kcDms-Folder-Location-pop-up-container" role="document">
    <form>
        <div class="col-sm-12 p-0">
            <div class="cmn-modal-header">
                <h3 class="modal-header-title">Folder location</h3>
            </div>
            <div class="cmn-modal-content">
                <div class="col-sm-12 p-0 mb-2">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex justify-content-start">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="cliencontact-title">
                                    <div>
                                        <div class="breadcrumb-wrapper">
                                            <ng-container>
                                                <ul class="breadcrumb">
                                                    <li><a class="home" data-testid="lnk-fl-home" (click)="homeBreadCrumbClicked()"><img
                                                                src="../../../../assets/images/home.svg" alt="home"></a>
                                                    </li>
                                                    <li *ngIf="breadcrumbData?.length === 0; else breadcrumbList ">
                                                        <a href="javascript:void(0);" data-testid="lnk-fl-group-name">
                                                            {{groupName}}
                                                        </a>
                                                    </li>

                                                    <ng-template #breadcrumbList>
                                                        <li *ngFor="let item of breadcrumbData; let i=index; let last=last;">
                                                            <a href="javascript:void(0);" data-testid="lnk-fl-breadcrumb" (click)="folderPath(item.Id)">
                                                                {{item.FolderName}}
                                                            </a>
                                                        </li>
                                                    </ng-template>
                                                </ul>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="cmn-grid-top-right-filters">
                            <div class="grid-search-filter" tabindex="1">
                                <img src="../../../../assets/img/search-icon/search_icon.svg" class="img-responsive" alt="icon"/>
                                <input class="form-control searchtext" data-testid="inp-fl-search" type="search" placeholder="Search" (keyup)="search()" (search)="searchKyePress()" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dms-folder-location-grid-container">
                    <div *ngIf="folders?.length" class="cmn-table-design client-list-grid with-dflt-chk">
                        <div [ngClass]="{'d-none': folders?.length == 0}" data-testid="grid-folderlist-container">

                            <ejs-grid #grid [dataSource]="folders" height="100%" data-testid="grid-fl-list" (dataBound)='onFolderLocationGridDataBound()' [allowResizing]="false" [allowReordering]="false"
                                [allowSorting]="true" [showColumnChooser]="false" [allowGrouping]="false"
                                enableInfiniteScrolling='true' [infiniteScrollSettings]='infiniteOptions'
                                [pageSettings]='options' [showColumnMenu]="false">
                                <!-- Column for Folder Name -->
                                <e-columns>
                                    <e-column field="FName" headerText="Name" textAlign="Left" width="200">
                                        <ng-template #template let-data>
                                            <a class="cursor-pointer PaddingLeft"
                                                matTooltipClass="cmn-tooltip-template"
                                                matTooltip="{{data.FName}}" (click)="folderPath(data.Id)" data-testid="lnk-fl-folder-name">
                                                <span class="icon-align-left">
                                                    <img src="../../../../assets/img/dms-icons/folder.svg" alt="folder" class="mr-1">
                                                </span>
                                                <span>
                                                    {{ data.FName }}
                                                </span>
                                            </a>
                                        </ng-template>
                                    </e-column>

                                    <!-- Column for Modified By -->
                                    <e-column field="ModifiedBy" headerText="Modified by" textAlign="Left"
                                        width="150">
                                        <ng-template #template let-data>
                                            <span>{{ data.ModifiedBy }}</span>
                                        </ng-template>
                                    </e-column>
                                    <!-- Column for Modified Date -->
                                    <e-column field="ModifiedDate" headerText="Modified date" type='date'
                                        textAlign="left" width="80"
                                        minWidth="80">
                                        <ng-template #template let-data>
                                            <span class="cursor-pointer" matTooltipClass="cmn-tooltip-template"
                                                matTooltip="{{ data.ModifiedDate| timezonedms | date: 'dd/MM/yyyy hh:mm a' }}">
                                                {{data.ModifiedDate | timezonedms | date: 'dd/MM/yyyy'}}
                                            </span>
                                        </ng-template>
                                    </e-column>
                                </e-columns>
                            </ejs-grid>
                        </div>

                    </div>
                    <div *ngIf="folders?.length == 0" class="d-flex justify-content-center align-items-center fs-5 norecord-msg-height">
                        No records
                        found.
                    </div>
                </div>
            </div>
            <div class="cmn-modal-footer">
                <button mat-button type="button" data-testid="btn-fl-fy-create" class="cmn-border-btn mr-2 create-fyfolder-btn" *ngIf="breadcrumbData?.length === 1" (click)="openCreateFYFolderPopup()">Create FY folder</button>
                <button type="button" data-testid="btn-select-folder" mat-button class="cmn-blue-btn mr-2" (click)="addFolderLocation()"
                    [disabled]="!(breadcrumbData?.length>1)">Select</button>
                <button type="button" data-testid="btn-fl-cancel" class="cmn-inverse-btn" mat-button 
                    (click)="closePopUp()">Cancel</button>
            </div>

        </div>
    </form>
</div>
<!-- create FY folder popup -->
<ng-template #createFYFolderPopup>
    <form>
        <div class="create-fy-folder-popup-container">
            <div class="cmn-modal-header">
                <h3 class="modal-header-title">Create FY folder</h3>
            </div>
            <div class="cmn-modal-content">
                <div class="form-select-container create-fy-folder-selct">
                    <ng-select [items]="financialYearFolderData?.fyFolderList"
                                data-testid="drpdwn-folder-select"
                                class="cmn-ngselect"
                                name="fyFolderSelect"
                                bindLabel="fyName"
                                bindValue="fyId"
                                [(ngModel)]="financialYearFolderData.selectedFyFolderId"
                                [clearable]="false"
                                [searchable]="true"
                                placeholder="Select financial year">
                    </ng-select>
                </div>
            </div>
            <div class="cmn-modal-footer">
                <button type="button" data-testid="btn-create-fy-folder" mat-button class="cmn-blue-btn mr-2" (click)="createFYFolder()" [disabled]="!financialYearFolderData?.selectedFyFolderId">Create</button>
                <button type="button" data-testid="btn-cancel-fy-create" class="cmn-inverse-btn" mat-button (click)="closeCreateFYFolderPopup()">Cancel</button>
            </div>
        </div>
    </form>
</ng-template>
<!-- create FY folder popup end -->